import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, computed, onBeforeUnmount } from "vue";


const __default__ = {
  name: "ClockWidget",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    timeFormat: {},
    showSeconds: { type: Boolean },
    fontFamily: {},
    fontSize: {},
    fontColor: {},
    fontWeight: {}
  },
  setup(__props: any) {

const props = __props;

const currentTime = ref(new Date());
const clockTimer = ref<number | null>(null);

const formattedTime = computed(() => {
  const hours = currentTime.value.getHours();
  const minutes = currentTime.value.getMinutes();
  const seconds = currentTime.value.getSeconds();

  // time format
  let formattedHours = hours;
  let hourString = "";

  if (props.timeFormat === "12h") {
    formattedHours = hours % 12;
    formattedHours = formattedHours || 12;
    hourString = formattedHours.toString();
  } else {
    // Add leading zero for hours in 24h format
    hourString = formattedHours.toString().padStart(2, "0");
  }

  const formattedMinutes = minutes.toString().padStart(2, "0");

  let timeString = `${hourString}:${formattedMinutes}`;
  if (props.showSeconds) {
    const formattedSeconds = seconds.toString().padStart(2, "0");
    timeString += `:${formattedSeconds}`;
  }

  if (props.timeFormat === "12h") {
    timeString += hours >= 12 ? " PM" : " AM";
  }

  return timeString;
});

onMounted(() => {
  updateTime();
  //update time every second
  const interval = props.showSeconds ? 1000 : 60000;
  clockTimer.value = window.setInterval(updateTime, interval);
});

onBeforeUnmount(() => {
  if (clockTimer.value) {
    window.clearInterval(clockTimer.value);
  }
});

function updateTime() {
  currentTime.value = new Date();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "clock-widget",
    style: _normalizeStyle({
      fontFamily: _ctx.fontFamily,
      fontSize: `${_ctx.fontSize}px`,
      color: _ctx.fontColor,
      fontWeight: _ctx.fontWeight === 'bold' ? 'bold' : 'normal',
      fontStyle: _ctx.fontWeight === 'italic' ? 'italic' : 'normal',
      textDecoration: _ctx.fontWeight === 'underline' ? 'underline' : 'none',
    })
  }, _toDisplayString(formattedTime.value), 5))
}
}

})